<!--查看争议-->
<template lang="pug">
    el-dialog(title="查看争议", width="40%", :visible.sync='visible' :append-to-body="true" @close="closeForm()")
      el-form(:model='dataForm',  :rules='rules', ref='dataForm', label-suffix=":" label-width="100px")
          el-form-item(label="提交人" prop="memberName")
              font.font_later {{dataForm.memberName}}
          el-form-item(label="争议内容" prop="content")
              el-input(v-model="dataForm.content" clearable   type="textarea" :rows=3 placeholder="请填写争议内容")

      span.dialog-footer(slot="footer")
          el-button(type="primary" @click='Submit') 提交修改
          el-button(type="primary" @click='deleteList') 删 除
          el-button(@click="closeForm()") 取 消
</template>
<script>
import util from '@/libs/util.js'
export default {
  name: 'UpdateGrade',
  data () {
    return {
      visible: false,
      dataForm: {
        memberName: '',
        content: ''
      },
      rules: {
        memberName: [
          { required: true, message: '提交人不能为空!', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '争议内容不能为空!', trigger: 'blur' }
        ]
      },
      id: ''
    }
  },
  mounted () {
    // this.getName()
  },
  methods: {
    getCookie: function (cname) {
        var name = cname + '='
        var ca = document.cookie.split(';')
        // console.log('获取cookie,现在循环')
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i]
          // console.log(c)
          while (c.charAt(0) == ' ') c = c.substring(1)
          if (c.indexOf(name) != -1) {
            return c.substring(name.length, c.length)
          }
        }
        return ''
      },
    init (row) {
      console.log(row)
      this.id = row.row.againstId

      this.$http({
        url: this.$http.adornUrl(`/ctCompetition/grade/debate/` + row.row.againstId),
        method: 'get'
      }).then((data) => {
        if (data.data != null && data.code === 0) {
          this.dataForm = data.data
        } else {
          this.dataForm = {
            memberName: this.getCookie('d2admin-1.0.0-username'),
            content: '',
            againstId: this.id
          }
        }
      })
      this.visible = true
    },
    deleteList () {
      this.$http({
        url: this.$http.adornUrl(`/ctCompetition/grade/debate/del/` + this.id),
        method: 'get'
      }).then((data) => {
        if (data && data.code === 0) {
          // this.dataForm = data.data
          this.$message({
            message: '操作成功',
            type: 'success',
            duration: 1500,
            onClose: () => {
              // this.$emit('SortFormatrList')
              this.$emit('refreshSortFormatrList')
              this.visible = false
            }
          })
        }
      })
    },
    Submit () {
      // this.$emit('refreshList')
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: this.$http.adornUrl(`/ctCompetition/grade/debate/club`),
            method: 'put',
            data: this.dataForm
          }).then((data) => {
            this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  // this.$emit('SortFormatrList')
                  this.$emit('refreshSortFormatrList')
                  this.visible = false
                }
              })
          })
        }
      })
    },
    closeForm () {
      this.visible = false
    }
  }
}
</script>
<style>
</style>
